import request from '@/utils/request'

const api = {
  create: '/api/retail/check/createBatch',
  approve: '/api/retail/check/approve',
  cancel: '/api/retail/check/cancel',
  detail: '/api/retail/check/detail',
  list: '/api/retail/check/list'
}

export default api

export function createCheckBatch(parameter) {
  return request({
    url: api.create,
    method: 'post',
    data: parameter
  })
}

export function approveCheck(parameter) {
  return request({
    url: api.approve,
    method: 'post',
    params: parameter
  })
}

export function cancelCheck(parameter) {
  return request({
    url: api.cancel,
    method: 'post',
    params: parameter
  })
}

export function getCheckDetail(parameter) {
  return request({
    url: api.detail,
    method: 'get',
    params: parameter
  })
}

export function getCheckList(parameter) {
  return request({
    url: api.list,
    method: 'get',
    params: parameter
  })
}
